import {Appointment, Provider, Vaccine} from '../../services/service-mappers/AppointmentSchedulingMapper';
import {
  IPatientTicketAndApptSummary,
  LocationsInterface
} from '../../services/service-mappers/PaymentServiceMapper';
import {
  PAYMENT_METHOD_ID,
  PATIENT_PAYMENT_DETAILS_ID,
  PATIENT_PAYMENT_TOKEN,
  SCHEDULE_SEND_DATE,
  GUARANTOR_CARD_PAYMENT,
  GUARANTOR_PAY_AMOUNT,
  GUARANTOR_PAY_CASH_AMOUNT,
  GUARANTOR_LOGIN,
  PAYMENT_CLINIC_DETAILS,
  PAYMENT_SHOW_DUE_NOTICE,
  PAYMENT_TYPE,
  ADHOC_PAYMENT_DATA,
  PAYMENT_AMOUNTS_DATA,
  BALANCE_FORWARD_DATA,
  LOCATIONS,
  INSTALLMENT_DETAILS,
  RESET_PAYMENTS_REDUCER,
  SET_APPOINTMENT_PORTAL_PATIENT_ID,
  SET_PATIENT_APPT_AND_TICKET_SUMMARY,
  UPDATE_SCHEDULED_APPOINTMENT,
  GET_APPOINTMENT_SLOT
} from './Index';

export const _paymentMethodId = (paymentMethodId: any): any => async (
  dispatch: any
) => {
  dispatch({type: PAYMENT_METHOD_ID, payload: {paymentMethodId}});
};

export const _patientPaymentDetailsId = (
  patientPaymentDetailsId: any
): any => async (dispatch: any) => {
  dispatch({
    type: PATIENT_PAYMENT_DETAILS_ID,
    payload: {patientPaymentDetailsId}
  });
};

export const _setPatientPaymentsToken = (
  patientPaymentsToken: any
): any => async (dispatch: any) => {
  dispatch({
    type: PATIENT_PAYMENT_TOKEN,
    payload: {patientPaymentsToken}
  });
};

export const _scheduleSendDate = (scheduleSendDate: any): any => async (
  dispatch: any
) => {
  dispatch({
    type: SCHEDULE_SEND_DATE,
    payload: {scheduleSendDate}
  });
};

export const _guarantorPaymentResult = (paymentResult: any): any => async (
  dispatch: any
) => {
  dispatch({
    type: GUARANTOR_CARD_PAYMENT,
    payload: {paymentResult}
  });
};

export const _guarantorPayAmount = (payAmount: any): any => async (
  dispatch: any
) => {
  dispatch({
    type: GUARANTOR_PAY_AMOUNT,
    payload: {payAmount}
  });
};
export const _guarantorPayCashAmount = (payCashAmount: any): any => async (
  dispatch: any
) => {
  dispatch({
    type: GUARANTOR_PAY_CASH_AMOUNT,
    payload: {payCashAmount}
  });
};

export const _guarantorLogin = (isLogin: any): any => async (dispatch: any) => {
  dispatch({
    type: GUARANTOR_LOGIN,
    payload: {isLogin}
  });
};

export const _saveClinicDetails = (data: any): any => async (dispatch: any) => {
  dispatch({
    type: PAYMENT_CLINIC_DETAILS,
    payload: {data}
  });
};

export const _updateShowDueNoticeFirstTime = (data: boolean): any => async (
  dispatch: any
) => {
  dispatch({
    type: PAYMENT_SHOW_DUE_NOTICE,
    payload: {data}
  });
};

export const _updatePaymentType = (paymentType?: string): any => async (
  dispatch: any
) => {
  dispatch({
    type: PAYMENT_TYPE,
    payload: {data: paymentType}
  });
};

export const _saveAdhocPaymentsData = (data: {
  patients?: Array<{
    id?: string;
    amount?: number;
    account_number?: string;
    first_name?: string;
    last_name?: string;
    middle_name?: string;
    email?: string;
    dob?: string;
    phone?: string;
  }>;
  guarantor?: {
    id?: string;
    account_number?: string;
    first_name?: string;
    middle_name?: string;
    last_name?: string;
    phone_1?: string;
    dob?: string;
    email?: string;
  };
  clinic_id?: string | number;
  payment_note?: string;
  insurance_name?: string;
}): any => async (dispatch: any) => {
  dispatch({
    type: ADHOC_PAYMENT_DATA,
    payload: {data}
  });
};

export const _saveAmountsAndRequiredDataForPayment = (data: {
  dueAmount: number | string;
  copayAmount: number | string;
  patientCopayIds: Array<string | number>;
  chargeTypesAmount: number | string;
  chargeTypesList: any;
  chargeTypeIds: any;
}): any => async (dispatch: any) => {
  dispatch({
    type: PAYMENT_AMOUNTS_DATA,
    payload: {data}
  });
};

export const _saveBalanceForwardData = (
  data: {
    amount: number;
    statementDate: string;
    guarantorDetails: {
      firstName: string;
      lastName: string;
      middleName: string;
    };
  } | null
): any => async (dispatch: any) => {
  dispatch({
    type: BALANCE_FORWARD_DATA,
    payload: {data}
  });
};

export const _setPracticeLocations = (
  locations: Array<LocationsInterface>
): any => async (dispatch: any) => {
  dispatch({
    type: LOCATIONS,
    payload: {locations}
  });
};

export const _setPayInInstallmentDetails = (details: any): any => async (
  dispatch: any
) => {
  dispatch({
    type: INSTALLMENT_DETAILS,
    payload: details
  });
};

export const _resetPaymentsReducer = (): any => async (dispatch: any) => {
  dispatch({
    type: RESET_PAYMENTS_REDUCER,
    payload: {}
  });
};

export const _setAppointmentPatientId = ({
  patientId = undefined,
  clinicId = undefined
}: {patientId?: number; clinicId?: number} = {}): any => async (
  dispatch: any
) => {
  dispatch({
    type: SET_APPOINTMENT_PORTAL_PATIENT_ID,
    payload: {patientId, clinicId}
  });
};

export const _setPatientTicketAndAppointmentSummary = ({
  patientApptAndTicketSummary
}: {
  patientApptAndTicketSummary: IPatientTicketAndApptSummary[];
}) => {
  return async (dispatch: any): Promise<any> => {
    dispatch({
      type: SET_PATIENT_APPT_AND_TICKET_SUMMARY,
      payload: {patientApptAndTicketSummary}
    });
  };
};

export const _setUpdateScheduledAppointment = ({
  updateAppointment = undefined,
  appointmentId = undefined,
  patientFirstName = undefined,
  patientLastName = undefined,
  patientMiddleName = undefined,
  appointmentAt = undefined,
  vaccineId = undefined,
  patientId = undefined,
  createdBy = undefined,
  vaccineName = '',
  duration = undefined,
  vaccine = undefined,
  appointment = undefined,
  provider = undefined
}: {
  updateAppointment?: boolean;
  appointmentId?: number;
  patientFirstName?: string;
  patientLastName?: string;
  patientMiddleName?: string;
  appointmentAt?: string;
  vaccineId?: number;
  patientId?: number;
  createdBy?: number;
  vaccineName?: string;
  duration?: number;
  vaccine?: Vaccine;
  appointment?: Appointment;
  provider?: Provider
} = {}): any => async (dispatch: any) => {
  dispatch({
    type: UPDATE_SCHEDULED_APPOINTMENT,
    payload: {
      updateAppointment,
      appointmentId,
      patientFirstName,
      patientLastName,
      patientMiddleName,
      appointmentAt,
      vaccineId,
      patientId,
      createdBy,
      vaccineName,
      duration,
      vaccine,
      appointment,
      provider
    }
  });
};

export const _getAppointemnetSlot = ({
  appointmentSlot = undefined
}: {
  appointmentSlot?: string | any;
} = {}): any => async (dispatch: any) => {
  dispatch({
    type: GET_APPOINTMENT_SLOT,
    payload: {appointmentSlot}
  });
};
